import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { getBasicAuthConfig, errorCatcher } from "../utils";
import ContentContainer from "../components/ContentContainer";
import SubContentContainer from "../components/SubContentContainer";
import CustomPageHeader from "../components/CustomPageHeader";
import {
  App,
  Form,
  Input,
  Button,
  // message,
  Spin,
  Modal,
  Tooltip,
  Upload,
  Space,
  Image,
  Row,
  Col,
  Select,
} from "antd";
import {
  QuestionCircleOutlined,
  UploadOutlined,
  EditOutlined,
} from "@ant-design/icons";

const { Option } = Select;

const CollectionCreateForm = ({
  visible,
  onCreate,
  onCancel,
  normFile,
  form,
}) => {
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  return (
    <Modal
      open={visible}
      title="Modification avatar"
      okText="Créer"
      cancelText="Annuler"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={{
          modifier: "public",
        }}
      >
        <Form.Item
          name="upload"
          label="Image"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          extra="Choisissez votre plus belle image 👌"
        >
          <Upload name="avatar" listType="picture" customRequest={dummyRequest}>
            <Button icon={<UploadOutlined />}>Sélectionner</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const Profile = () => {
  const { message } = App.useApp();
  let history = useHistory();
  const [inputData, setInputData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [urlAvatar, setUrlAvatar] = useState(undefined);

  const [form] = Form.useForm();
  // TODO: When user uploads a new avatar, image does not change after click yes, need to refresh the page which is not good
  const onCreate = async () => {
    // console.log("Upload logo clicked !!!");
    try {
      if (!selectedFile !== null) {
        const formData = new FormData();
        formData.append("avatar", selectedFile, selectedFile.name);
        await axios.post(
          process.env.REACT_APP_API_URL + "/users/me/avatar",
          formData,
          getBasicAuthConfig()
        );
        setUrlAvatar(
          process.env.REACT_APP_API_URL +
            "/users/" +
            inputData._id +
            "/avatar" +
            `?${new Date()}`
        );
      }
      message.success("Logo/Avatar envoyé avec succès");
    } catch (e) {
      console.log(e);
      if (e.response && e.response.data.error) {
        message.error(
          `Erreur lors de l'envoi de l'image (${e.response.data.error}))`
        );
        setVisible(false);
      } else {
        message.error("Erreur lors de l'envoi de l'image");
        setVisible(false);
      }
    }
    setVisible(false);
  };

  const normFile = (e) => {
    if (e.fileList[0] !== undefined) {
      setSelectedFile(e.fileList[0].originFileObj);
    }
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const onFinish = async (values) => {
    // console.log(values);
    const allowedUpdates = [
      "gender",
      "firstname",
      "lastname",
      "enterprise",
      "username",
      "email",
      "password",
      "telephonemonsieur",
      "telephonemadame",
      "mailmonsieur",
      "mailmadame",
    ];
    const updateData = {};
    for (const property in values) {
      if (allowedUpdates.includes(property)) {
        updateData[property] = values[property];
      }
    }
    if (
      values.newpasswordone !== "" &&
      values.newpasswordtwo !== "" &&
      values.newpasswordone === values.newpasswordtwo
    ) {
      // updateData["oldPassword"] = values.password;
      updateData["newPassword"] = values.newpasswordone;
      updateData["oldPassword"] = values.oldpassword;
    }
    try {
      await axios.patch(
        process.env.REACT_APP_API_URL + "/users/me",
        updateData,
        getBasicAuthConfig()
      );
      history.push("/profile");
      message.success("Informations correctement mises à jour.");
    } catch (e) {
      message.error(
        `Erreur lors de la mise à jour. Veuillez vérifier le formulaire.`
      );
      console.log(e);
    }
  };

  const loadUserProfile = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/users/me",
        getBasicAuthConfig()
      );

      // console.log(`RES.DATA ====> ${JSON.stringify(res.data)}`);
      const inputDataObj = res.data;
      inputDataObj["newpasswordone"] = "";
      inputDataObj["newpasswordtwo"] = "";
      setInputData(res.data, ("newpasswordone": ""), ("newpasswordtwo": ""));
      // console.log("RES FETCH = > " + JSON.stringify(res.data));
      setUrlAvatar(
        process.env.REACT_APP_API_URL +
          "/users/" +
          res.data._id +
          "/avatar" +
          `?${new Date()}`
      );
      // await loadUrlAvatar(res.data._id);
      // setIsImgLoaded(false);
    } catch (e) {
      errorCatcher(e, `Erreur lors du chargement de votre profil`);
    }
  };

  useEffect(() => {
    const newFunc = async () => {
      await loadUserProfile();
      setIsLoading(false);
    };
    newFunc();
  }, []);

  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 8 },
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 4,
        offset: 0,
      },
      sm: {
        span: 8,
        offset: 4,
      },
    },
  };

  if (isLoading) {
    return (
      <ContentContainer>
        <div className="loader-spin">
          <Spin />
        </div>
      </ContentContainer>
    );
  } else {
    return (
      <ContentContainer>
        <SubContentContainer>
          <CustomPageHeader
            arrow={true}
            title="Informations personnelles"
            subTitle="Modifier"
          />
          <div>
            <Row>
              <Col span={4}></Col>
              <Col span={8}>
                <br />

                <p>Avatar :</p>
                <Space>
                  <Image
                    style={{ width: 300, border: "none" }}
                    src={urlAvatar === undefined ? "error" : urlAvatar}
                    fallback="data:image/png;base64,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"
                  />

                  <Button
                    icon={<EditOutlined />}
                    onClick={() => {
                      setVisible(true);
                    }}
                  />

                  <CollectionCreateForm
                    visible={visible}
                    onCreate={onCreate}
                    onCancel={() => {
                      setVisible(false);
                    }}
                    normFile={normFile}
                    form={form}
                  />
                </Space>
              </Col>
              <Col span={4}></Col>
            </Row>
            <br />
            <br />
            <Form
              {...formItemLayout}
              form={form}
              name="updates"
              onFinish={onFinish}
              initialValues={{
                gender: inputData.gender || "",
                firstname: inputData.firstname || "",
                lastname: inputData.lastname || "",
                enterprise: inputData.enterprise || "",
                username: inputData.username || "",
                email: inputData.email || "",
                mailmonsieur: inputData.mailmonsieur || undefined,
                mailmadame: inputData.mailmadame || undefined,
                telephonemadame: inputData.telephonemadame || undefined,
                telephonemonsieur: inputData.telephonemonsieur || undefined,
              }}
              scrollToFirstError
            >
              <Form.Item name="gender" label="Titre">
                <Select>
                  <Option value="Monsieur">Monsieur</Option>
                  <Option value="Madame">Madame</Option>
                  <Option value="Autre">Autre</Option>
                </Select>
              </Form.Item>

              <Form.Item name="firstname" label="Nom">
                <Input />
              </Form.Item>

              <Form.Item name="lastname" label="Prénom">
                <Input />
              </Form.Item>

              <Form.Item name="enterprise" label="Entreprise">
                <Input />
              </Form.Item>

              <Form.Item
                name="username"
                label={
                  <span>
                    Nom d'utilisateur&nbsp;
                    <Tooltip title="Celui qui apparaît dans votre barre de navigation">
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </span>
                }
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="email"
                label="E-mail"
                rules={[
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                  {
                    message: "Please input your E-mail!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="telephonemonsieur"
                label="Téléphone 1"
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(
                      /^\+?[1-9]\d{1,14}$|^((\+)33|0)[1-9](\d{2}){4}$/g
                    ),
                    message:
                      "Veuillez renseigner au moins un numéro de téléphone (format : 0689... ou +337...)",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="telephonemadame"
                label="Téléphone 2"
                rules={[
                  {
                    pattern: new RegExp(
                      /^\+?[1-9]\d{1,14}$|^((\+)33|0)[1-9](\d{2}){4}$/g
                    ),
                    message:
                      "Veuillez renseigner au moins un numéro de téléphone (format : 0689... ou +337...)",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="mailmonsieur" label="Email 1">
                <Input />
              </Form.Item>

              <Form.Item name="mailmadame" label="Email 2">
                <Input />
              </Form.Item>

              <Form.Item
                name="oldpassword"
                label="Ancien mot de passe"
                rules={[
                  {
                    message: "Veuillez saisir votre mot de passe actuel",
                  },
                ]}
                hasFeedback
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                name="newpasswordone"
                label="Nouveau mot de passe"
                rules={[
                  {
                    message: "Veuillez saisir votre nouveau mot de passe",
                  },
                ]}
                hasFeedback
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                name="newpasswordtwo"
                label="Confirmation"
                dependencies={["newpasswordone"]}
                hasFeedback
                rules={[
                  {
                    message: "Veuillez confirmer votre nouveau mot de passe",
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("newpasswordone") === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        "Les mots de passe ne correspondent pas !"
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit">
                  Mettre à jour
                </Button>
              </Form.Item>
            </Form>
          </div>
        </SubContentContainer>
      </ContentContainer>
    );
  }
};

export default Profile;
